import script from "./LessonEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonEdit.vue?vue&type=script&setup=true&lang=js"

import "./LessonEdit.vue?vue&type=style&index=0&id=6bbb367c&lang=css"

const __exports__ = script;

export default __exports__